import styled, { css } from 'styled-components';

import Link from 'Elements/Link';

export const Container = styled.article`
    ${({ theme }) => css`
        position: relative;
        display: flex;
        border: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[1].hex};
        border-radius: 0.5rem;
        overflow: hidden;
    `}
`;

export const Tag = styled.div`
    ${({ theme }) => css`
        position: absolute;
        top: 0;
        right: 0;
        padding: 0.2rem 0.5rem;
        background: ${theme.colors.primary.hex};
        color: ${theme.colors.primaryContrast.hex};
        font-size: 1rem;

        &::first-letter {
            text-transform: capitalize;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        min-width: 10rem;
        width: 10rem;
        height: auto;
        display: none;

        @media ${theme.breakpoints.large.media} {
            display: block;
        }
    `}
`;

export const Inner = styled.div`
    ${({ theme }) => css`
        padding: 1.5rem 1rem;

        @media ${theme.breakpoints.large.media} {
            padding: 1.5rem 2rem;
        }
    `}
`;

export const StyledLink = styled(Link)`
    &::after {
        content: '';
        position: absolute;
        inset: 0;
    }
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        margin-top: 0.5rem;
        margin-bottom: 0.625rem;
        font-size: 1.25rem;
        line-height: 1.3;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.375rem;
        }
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        font-size: 1rem;
        margin: 0;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.25rem;
        }
    `}
`;
